import React from 'react';
import PropTypes from 'prop-types';
import styles from './core-download-progress.css';

const CoreDownloadProgress = ({percent, label}) => (
    <div className={styles.container}>
        <div className={styles.header}>
            <svg
                className={styles.icon}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                    fill="#4C97FF"
                />
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 14.5l-5-3 5-3v6z"
                    fill="#4C97FF"
                />
            </svg>
            <span className={styles.title}>{'正在准备编译环境'}</span>
        </div>
        {label ? (
            <div className={styles.label}>{label}</div>
        ) : null}
        <div className={styles.track}>
            <div
                className={styles.bar}
                style={{width: `${percent}%`}}
            />
        </div>
        <div className={styles.percent}>{`${percent}%`}</div>
    </div>
);

CoreDownloadProgress.propTypes = {
    percent: PropTypes.number.isRequired,
    label: PropTypes.string
};

CoreDownloadProgress.defaultProps = {
    label: ''
};

export default CoreDownloadProgress;
